var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00016 6.66663V4.66663C3.00016 3.60576 3.42159 2.58834 4.17174 1.8382C4.92188 1.08805 5.9393 0.666626 7.00016 0.666626C8.06103 0.666626 9.07844 1.08805 9.82859 1.8382C10.5787 2.58834 11.0002 3.60576 11.0002 4.66663V6.66663H11.6668C12.7714 6.66663 13.6668 7.56206 13.6668 8.66663V13.3333C13.6668 14.4379 12.7714 15.3333 11.6668 15.3333H2.3335C1.22893 15.3333 0.333496 14.4379 0.333496 13.3333V8.66663C0.333496 7.56206 1.22893 6.66663 2.3335 6.66663H3.00016ZM5.11454 2.78101C5.61464 2.28091 6.29292 1.99996 7.00016 1.99996C7.70741 1.99996 8.38568 2.28091 8.88578 2.78101C9.38588 3.2811 9.66683 3.95938 9.66683 4.66663V6.66663H4.3335V4.66663C4.3335 3.95938 4.61445 3.2811 5.11454 2.78101ZM2.3335 7.99996C1.96531 7.99996 1.66683 8.29844 1.66683 8.66663V13.3333C1.66683 13.7015 1.96531 14 2.3335 14H11.6668C12.035 14 12.3335 13.7015 12.3335 13.3333V8.66663C12.3335 8.29844 12.035 7.99996 11.6668 7.99996H2.3335Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0a12e37f.svg";
export { ForwardRef as ReactComponent };